import {Injectable} from '@angular/core';
import {HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {catchError, Observable, throwError} from 'rxjs';
import {NzNotificationService} from 'ng-zorro-antd/notification';
import {AuthStorageService} from "../services/utils/auth-storage/auth-storage.service";
import {Router} from "@angular/router";
import {AppRoutes} from "../routes/app-routes";

@Injectable()
export class CheckAuthInterceptor implements HttpInterceptor {
  private excludedRoutes: string[] = [
    '/admin/auth/login',
  ];

  constructor(private notificationService: NzNotificationService, private readonly authStorageService: AuthStorageService, private readonly router: Router) {
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (this.isExcludedRoute(request.url)) {
      return next.handle(request);
    }

    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401) {
          this.authStorageService.clearAll();
          this.showNotification('احراز هویت', 'توکن شما منقضی شده یا به این بخش دسترسی ندارید.');
          this.router.navigate([AppRoutes.AUTH.LOGIN]);
        }
        return throwError(() => error);
      })
    );
  }

  private isExcludedRoute(url: string): boolean {
    return this.excludedRoutes.some(route => url.includes(route));
  }

  private showNotification(title: string, content: string): void {
    this.notificationService.blank(title, content, {nzDuration: 3000});
  }
}
